import { createSlice } from "@reduxjs/toolkit";

export const paylaterSlice = createSlice({
  name: "merchant",
  initialState: {
    merchants: [],
    categories: [],
    subcategories: [],
    cate_relation: [],
    cate_logo: [],
    default_popular: null,
    search: "",
    selected_category: null,
    selected_subcategory: "",
    loading: null,
    filter_popular_merchants: null,
    filter_merchants: null,
    search_popular_merchants: null,
    search_all_merchants: null,
  },
  reducers: {
    setMerchants: (state, action) => {
      const data = action.payload.data.map((m) => {
        const keysArray = m.keys.split(";");
        return { ...m, keys: keysArray };
      });
      state.merchants = data;
      const temp = action.payload.data;

      // state.merchants?.sort((a, b) => a.seq - b.seq);
      // const sortedArray = [...state.merchants].sort((a, b) => a.seq - b.seq);
      const sortedArray = [...state.merchants].sort((a, b) => {
        if (a.seq !== "" && b.seq !== "") {
          return parseInt(a.seq) - parseInt(b.seq);
        } else if (a.seq !== "") {
          return -1; // a.seq is not empty, so it comes before b.seq
        } else if (b.seq !== "") {
          return 1; // b.seq is not empty, so it comes before a.seq
        } else {
          return 0; // both a.seq and b.seq are empty, no preference in order
        }
      });
      state.merchants = sortedArray;
      // let cat = state.merchants.map((m) => m.cate_th);
      let cate_logo = state.merchants.map(({ cate_th, cate_logo }) => ({
        cate_th,
        cate_logo,
      }));

      // let subcat = state.merchants.map((m) => m.subcate);
      let subcat = state.merchants.map((m) => m.subcate).filter((x) => x);
      let popular = state.merchants.filter((m) => m.fg == "Y");
      let all = { cate_th: "ร้านค้ายอดนิยม", cate_logo: "popular" };
      cate_logo.unshift(all);
      state.categories = [...new Set(cate_logo)];
      const uniqueData = Array.from(new Set(state.categories.map(JSON.stringify))).map(JSON.parse);

      const result = uniqueData.filter(
        (obj, index, self) =>
          index ===
          self.findIndex((o) => o.cate_th === obj.cate_th && o.cate_logo === obj.cate_logo)
      );
      state.categories = result;
      state.subcategories = [...new Set(subcat)];

      state.default_popular = [...new Set(popular)];
      // state.sort = [...new Set(cate_logo)];
      let relation = state.categories.map((c) => {
        let temp = state.merchants.filter((m) => m.cate_th == c);
        let temp2 = temp.map((t) => t.subcate);
        let arr = [];
        arr[c] = [...new Set(temp2)];
        return arr;
      });

      state.cate_relation = relation;
    },
    setSelectedCategory: (state, action) => {
      state.selected_category = action.payload;
    },
    setSelectedSubCategory: (state, action) => {
      if (action.payload == "ทั้งหมด") {
        state.selected_subcategory = null;
      } else {
        state.selected_subcategory = action.payload;
      }
    },
    unselectedCategory: (state, action) => {
      state.selected_category = null;
      state.selected_subcategory = null;
      state.filter_popular_merchants = null;
      state.filter_merchants = null;
    },
    filterCategory: (state, action) => {
      state.filter_merchants = state.merchants.filter((m) => m.cate_th == state.selected_category);
      state.filter_popular_merchants = state.filter_merchants.filter((m) => m.fg == "Y");

      if (state.selected_category != "ร้านค้ายอดนิยม") {
        let temp = state.filter_merchants.map((m) => m.subcate).filter((x) => x);
        // let temp = state.filter_merchants.map((m) => m.subcate);

        if (temp != 0) {
          state.subcategories = [...new Set(temp)];
        } else {
          state.subcategories = null;
        }
      } else {
        let subcat = state.merchants.map((m) => m.subcate);
        state.subcategories = [...new Set(subcat)];
      }
      let s = state.subcategories?.length ? state.subcategories : [];
      state.subcategories = s;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      if (state.selected_category != null) {
        state.filter_merchants = state.filter_merchants.filter(
          (m) =>
            m.nm_en.toLowerCase().includes(action.payload.toLowerCase()) ||
            m.nm_th.includes(action.payload) ||
            m.keys.includes(action.payload)
        );
      } else {
        state.filter_merchants = state.merchants.filter(
          (m) =>
            m.nm_en.toLowerCase().includes(action.payload.toLowerCase()) ||
            m.nm_th.includes(action.payload) ||
            m.keys.includes(action.payload)
        );
      }
      state.filter_merchants = state.filter_merchants.filter(
        (m) =>
          m.nm_en.toLowerCase().includes(action.payload.toLowerCase()) ||
          m.nm_th.includes(action.payload) ||
          m.keys.includes(action.payload)
      );

      console.log("🚀 ------------------------------------------------------------------------------🚀")
      console.log("🚀 ~ file: paylaterSlice.js:128 ~ tate.filter_merchants:", state.filter_merchants)
      console.log("🚀 ------------------------------------------------------------------------------🚀")

      state.filter_popular_merchants = state.filter_merchants.filter((m) => m.fg == "Y");
    },
    clearSearch: (state, action) => {
      state.search = "";
      state.filter_merchants = null;
      state.filter_popular_merchants = null;
      state.selected_category = null;
      state.selected_subcategory = "";
    },
    filterSubCategory: (state, action) => {
      if (state.selected_subcategory != null) {
        state.filter_merchants = state.merchants.filter(
          (m) => m.subcate == state.selected_subcategory
        );

        state.filter_popular_merchants = state.filter_merchants.filter((m) => m.fg == "Y");
      } else {
        state.filter_merchants = state.merchants.filter(
          (m) => m.cate_th == state.selected_category
        );
        state.filter_popular_merchants = state.filter_merchants.filter((m) => m.fg == "Y");
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setMerchants,
  setSelectedCategory,
  setSelectedSubCategory,
  updateMerchants,
  filterCategory,
  filterSubCategory,
  setSearch,
  clearSearch,
  unselectedCategory,
} = paylaterSlice.actions;

export default paylaterSlice.reducer;
